import React, {useEffect, useMemo, useState} from 'react';
import {Radio} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import {t} from '../../../../../../services/i18n';
import AppText from '../../../../../common/AppText';
import {Colors} from '../../../../../../styles/Colors';
import {optionalSteps} from '../StepOptions';
import {flowOptions} from '../FlowOptions';
import {updateTempSelection} from '../../../../../../redux/stepperSlice';
import CustomButtonV2 from '../../../../../common/CustomButtonV2';
import HStack from '../../../../../common/Layout/HStack';
import VStack from '../../../../../common/Layout/VStack';

const SwapType = () => {
    const dispatch = useDispatch();
    const selectionsTree = useSelector(state => state.stepper.selectionsTree);
    const [selection, setSelection] = useState(flowOptions.SWAP_HUG_REGISTRATION);

    const types = useMemo(() => [
        {
            id: flowOptions.SWAP_HUG_REGISTRATION,
            name: t('swap-type-course-label'),
            explain: t('swap-type-course-desc'),
        },
        {
            id: flowOptions.SWAP_HUG_DAY_REGISTRATION,
            name: t('swap-type-day-label'),
            explain: t('swap-type-day-desc'),
        },
    ], []);

    useEffect(() => {
        const saved = selectionsTree[optionalSteps.SWAP_TYPE];
        if (saved) {
            setSelection(saved);
        }
    }, []);

    useEffect(() => {
        dispatch(updateTempSelection({[optionalSteps.SWAP_TYPE]: selection}));
    }, [selection]);

    return (
        <Radio.Group name={'swap-type-radio'} value={selection}>
            <VStack space={'1rem'} style={{width: '100%'}}>
                {types.map((type) => (
                    <CustomButtonV2
                        key={type.id}
                        wrapperStyle={{width: '100%'}}
                        onClick={() => setSelection(type.id)}
                        iconProps={{iconColor: Colors.borderColor, iconHoverColor: Colors.newDesign.mainBlue}}
                        override={({color}) => (
                            <HStack
                                alignItems={'flex-start'}
                                space={'0.5rem'}
                                style={{
                                    padding: '1rem',
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    border: `1px solid ${selection === type.id ? Colors.newDesign.mainBlue : color}`,
                                    borderRadius: 4,
                                }}
                            >
                                <Radio value={type.id} size="sm" />
                                <VStack style={{flex: 1, minWidth: 0}}>
                                    <AppText boldFont>{type.name}</AppText>
                                    <AppText>{type.explain}</AppText>
                                </VStack>
                            </HStack>
                        )}
                    />
                ))}
            </VStack>
        </Radio.Group>
    );
};

export default SwapType;
